module.exports = __webpack_public_path__ + "static/media/icon-add-amber.3e61aca7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/icon-add-amber.svg
// module id = 967
// module chunks = 57